import { notification } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useReviewerApprove } from "../mutate-hooks/use-reviewer-approve";

interface IUseConfirmReviewerApproveModal {
  setIsLoading?: (isLoading: boolean) => void;
  handleClear: () => void;
}

export const useConfirmReviewerApproveModal = ({
  setIsLoading,
  handleClear,
}: IUseConfirmReviewerApproveModal) => {
  const { titleId } = useCoordinator();
  const { mutate: reviewerApprove } = useReviewerApprove({ titleId });
  const handleConfirmReviewerApprove = async () => {
    setIsLoading?.(true);
    reviewerApprove({
      onSuccess: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.TITLE_REVIEWED_DESC, // "Титульный лист проверен"
            placement: "topRight",
          });
        handleClear();
      },
      onError: () => {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.TITLE_REVIEW_FAILED_DESC, // "Титульный лист не проверен"
            placement: "topRight",
          });
        handleClear();
      },
      onSettled: () => {
        setIsLoading?.(false);
      },
    });
  };

  return { handleConfirmReviewerApprove };
};
